import React from 'react';

const SubPrivatePolicy = () => {
  return (
    <section className='sub-text-box' id='sub-text-box'>
      <h1>Privacy Policy</h1>
      <p>WE REGARD AND RESPECT BOUNDARIES.</p>
    </section>
  );
};

export default SubPrivatePolicy;
